import { render, staticRenderFns } from "./ordensDeServico.vue?vue&type=template&id=4d899500"
import script from "./ordensDeServico.vue?vue&type=script&lang=js"
export * from "./ordensDeServico.vue?vue&type=script&lang=js"
import style0 from "./ordensDeServico.vue?vue&type=style&index=0&id=4d899500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports